import React from 'react';
import {
  useActiveSyncJobsStatus,
  useAutomationTemplates,
} from '../../useAutomationTemplates';
import { TemplatesTable } from './TemplatesTable';
import { TemplatesTableLoading } from './TemplatesTableLoading';
import { TemplatesTableError } from './TemplatesTableError';

export const TemplatesManager: React.FC = () => {
  const { data: templatesData, isLoading, error } = useAutomationTemplates();
  const { data: syncStatus, isLoading: isLoadingSyncStatus } =
    useActiveSyncJobsStatus();

  const templates = templatesData?.templates || [];
  const hasActiveJobs = syncStatus?.hasActiveJobs ?? false;
  const isSyncInProgress = hasActiveJobs || isLoadingSyncStatus || isLoading;

  if (isLoading) {
    return <TemplatesTableLoading />;
  }

  if (error) {
    return <TemplatesTableError error={error} />;
  }

  return (
    <TemplatesTable templates={templates} isSyncInProgress={isSyncInProgress} />
  );
};
